import { render, staticRenderFns } from "./ProjectTableNewsLetters.vue?vue&type=template&id=9a77b690&"
import script from "./ProjectTableNewsLetters.vue?vue&type=script&lang=js&"
export * from "./ProjectTableNewsLetters.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTableNewsLetters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports